import React,{useState } from 'react'
import { ToastContainer } from "react-toastify";

import {data} from "./data";
import ErrorBoundary from "components/ErrorBoundary";
import SearchBiTool from './components/SearchContainer';
import TopDrugs from './components/Widgets/TopDrugs';
import TopPharmacy from './components/Widgets/TopPharmacy';
import TopCoveredEntities from './components/Widgets/TopCoveredEntities';
import { Card, CardBody, Container,Row,Col } from 'reactstrap';
import BiToolTable from './components/BIToolTable';

const BiToolSearch = () => {
  const [state, updateState] = useState({
    biToolData: [],
    loading: false,
  });

  const [pageFilter, setPageFilter] = useState({
    page: 1,
    pageSize: 10,
    records: 0
  });


  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  let copyData = [...data];

  const handlePageChange = ({currentPage: page}) => {
    const { pageSize } = pageFilter;
    console.log({page})
    setState({loading: true})
    setTimeout(() => {
      let splicedData = copyData.slice((page === 1 ? 0 : page * pageSize) , pageSize * (page + 1));
      setPageFilter(pre => ({...pre, page: page}));
      setState({loading: false, biToolData: splicedData });
    },600);
  };

  const onSearch = () => {
    const { page, pageSize } = pageFilter;
    setState({ loading: true });
    setTimeout(() => {
      let splicedData = copyData.slice((page === 1 ? 0 : page * pageSize) , pageSize);
      setPageFilter(pre => ({...pre, records: copyData.length}))
      setState({
        loading: false,
        biToolData: splicedData,
      });
    }, 2000);
  };

  const onReset = () => {
    setState({ biToolData: [] });
  };

  const onPageSizeChange = ({pageSize}) => {
    setState({loading: true})
    setTimeout(() => {
      let splicedData = copyData.slice(0, pageSize);
      setPageFilter(pre => ({...pre, pageSize: pageSize, page: 1}));
      setState({loading: false, biToolData: splicedData})
    },600);
  };

  const { biToolData, loading } = state;
  return (
    <div>
      <Row sm={2} xs={1}>
        <Col className='mt-3' md={4}>
          <TopCoveredEntities />
        </Col>
        <Col className='mt-3' md={4}>
          <TopPharmacy />
        </Col>
        <Col className='mt-3' md={4}>
          <TopDrugs />
        </Col>
      </Row>
      <Container fluid className="my-3">

        <Card className="border-0 shadow-top">
          <CardBody className="section-devider-border">
            <ErrorBoundary>
              <SearchBiTool onSearch={onSearch} onReset={onReset} />
            </ErrorBoundary>
          </CardBody>
          <CardBody>
            <ErrorBoundary>
            <BiToolTable
              data={biToolData}
              loading={loading}
              onPageChange={handlePageChange}
              // onSearchColumnFilters={handleSearchColumnFilters}
              onPageSizeChange={onPageSizeChange}
              pageFilter={pageFilter}
            />
          </ErrorBoundary>
          </CardBody>
        </Card>
      </Container>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  )
}

export default BiToolSearch;